import React, { Component } from "react";
import { ExValLookUp, ExValLookupData } from "../../valuationapi/entities";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import Strings from "@my-dld/assets/strings";
import { LocaleUtil } from "@eres/core";
import { populateExValLookup } from "../../valuationapi/services";
import PickerInput from "@eres/forms-web/PickerInput";
import { TabuPropertyType } from "@my-dld/utils/PropertyUtils";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import FormRow from "@eres/forms-web/FormRow";
import TextInputField from "../Form/TextInputField";
import BuildingValuationForm from "./BuildingValuationForm";
import VillaValuationForm from "./VillaValuationForm";
import LandValuationForm from "./LandValuationForm";
import UnitValuationForm from "./UnitValuationForm";
import CheckBoxField from "../Form/CheckBoxField";

interface LookupState {
	PropertyTypes?: ExValLookupData[];
	Reasons?: ExValLookupData[];
	RequestSource?: ExValLookupData[];
}


interface Props {
	property: AssetCard,
	isEmptyLand: boolean,
	onValuationReasonChange: ( reason: ExValLookupData ) => void,
	onValuationScopeChange: ( scope: ExValLookupData ) => void,
	onCancel: () => void,
	onSubmit: ( remarks: String | undefined ) => void,
}

interface State extends LookupState {
	remarks?: String;
	propertyType?: String;
	propertySize?: number;
	agree_terms: boolean;
	reasonId?: number;
	propertyId?: number;
	formErrors: { [ k: string ]: string | undefined };
}

class ValuationDetailsForm extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			agree_terms: false,
			formErrors: {},
			propertyType: LocaleUtil.getLocalValue( this.props.property.propertyType ),
			propertySize: this.props.property.size.squareMeter
		};
	}

	private static renderProperty( property: AssetCard ) {
		switch ( property.propertyTypeId ) {
			case TabuPropertyType.LAND:
				return ( <LandValuationForm property={ property }/> );

			case TabuPropertyType.BUILDING:
				return ( <BuildingValuationForm property={ property }/> );

			case TabuPropertyType.UNIT:
				return ( <UnitValuationForm property={ property }/> );

			case TabuPropertyType.VILLA:
				return ( <VillaValuationForm property={ property }/> );

			default:
				return undefined;
		}
	}

	componentDidMount() {
		populateExValLookup( ExValLookUp.REASONS, this );
		populateExValLookup( ExValLookUp.PROPERTY_TYPES, this );
		populateExValLookup( ExValLookUp.REQUEST_SOURCE, this );
	}

	render() {
		let property: any = this.props.property;
		let buildingName = property.buildingName;
		const { Reasons, RequestSource, PropertyTypes, formErrors } = this.state;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-md-12 form-group",
		};
		const formProps = {
			containerClassName: "form-group mb-4 field-style",
			inputClassName: "form-control",
			holder: this,
		};
		return <>
			<div className="card">
				<div className="card-header">
					<span>{ Strings.evaluation_form }</span>
				</div>
				<div className="card-body">
					<div className="mandatory-field-info">
						<small>{ Strings.mandatory_fields_note }</small>
					</div>
					<div className="row">
						{ ValuationDetailsForm.renderProperty( this.props.property ) }
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
							<TextInputField
								id={ "propertyType" }
								holder={ this }
								required={ false }
								label={ Strings.type }
								disabled={ true }
								containerClassName={ "form-group field-style mb-4" }
								inputClassName={ "form-control" }/>
						</div>
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
							<TextInputField
								id={ "propertySize" }
								holder={ this }
								required={ false }
								label={ Strings.area_size_sq_mt }
								disabled={ true }
								containerClassName={ "form-group field-style mb-4" }
								inputClassName={ "form-control" }/>
						</div>
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
							<FormRow { ...filedProps }>
								<PickerInput
									required={ true }
									isLoading={ Reasons === undefined }
									id={ "reasonId" }
									toIdentifier={ idExtractor }
									label={ Strings.valuation_reason }
									formatter={ ( reason: ExValLookupData ) => LocaleUtil.getLocalValue( reason.name ) }
									onValueChange={ ( reason: any ) => {
										this.props.onValuationReasonChange( reason );
									} }
									error={ formErrors.reasonId }
									items={ Reasons }
									containerClassName={ "form-group field-style select-control mb-4" }/>
							</FormRow>
						</div>

						{ this.props.property.propertyTypeId === TabuPropertyType.LAND && !this.props.isEmptyLand &&
							<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
								<FormRow { ...filedProps }>
									<PickerInput
										required={ true }
										isLoading={ PropertyTypes === undefined }
										id={ "propertyId" }
										toIdentifier={ idExtractor }
										label={ Strings.valuation_scope }
										formatter={ ( scope: ExValLookupData ) => LocaleUtil.getLocalValue( scope.name ) }
										onValueChange={ ( scope: any ) => {
											this.props.onValuationScopeChange( scope );
										} }
										error={ formErrors.propertyId }
										items={ PropertyTypes }
										containerClassName={ "form-group field-style select-control mb-4" }/>
								</FormRow>
							</div> }

						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							<TextInputField
								{ ...formProps }
								id={ "remarks" }
								label={ Strings.notes }
								required={ false }
								maxLength={ 256 }
								customInput={ <textarea rows={ 4 }/> }
								onValueChange={ ( value, extra ) => {
									this.setState( { remarks: value } );
								} }
								containerClassName={ "form-group field-style" }
							/>
						</div>
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							<CheckBoxField
								id={ "agree_terms" }
								holder={ this }
								required={ true }
								label={ Strings.terms_conditions }
								error={ formErrors.agree_terms }/>
						</div>
					</div>
				</div>
			</div>
			<div className="mt-3 mb-3">
				<a className="btn btn-grey btn_style1 me-2" onClick={ this.onCancel }>{ Strings.cancel }</a>
				<button
					onClick={ this.onSubmit } className="btn btn_1 btn_style1" type="submit" data-bs-toggle="modal"
					data-bs-target="#ValuationFormSuccess">{ Strings.submit }
				</button>
			</div>
		</>;
	}

	private onCancel = () => {
		this.props.onCancel();
	};

	private onSubmit = () => {
		if ( this.validateInputs() ) {
			this.props.onSubmit( this.state.remarks );
		}
	};

	private validateInputs() {
		let isValid: boolean = true;
		const { agree_terms } = this.state;
		const error: { [ k: string ]: string } = {};
		if ( !this.state.reasonId ) {
			error.reasonId = Strings.required;
			isValid = false;
		}

		if ( !agree_terms ) {
			error.agree_terms = Strings.required;
			isValid = false;
		}

		if ( this.props.property.propertyTypeId === TabuPropertyType.LAND && !this.props.isEmptyLand ) {
			if ( !this.state.propertyId ) {
				error.propertyId = Strings.required;
				isValid = false;
			}
		}

		this.setState( {
			formErrors: error,
		} );

		return isValid;
	}
}

const idExtractor = ( e: any ) => e ? "" + e.id : undefined;
export default ValuationDetailsForm;
